// extracted by mini-css-extract-plugin
module.exports = {"case-card":"CaseCard_case-card__mQhu1","image-container":"CaseCard_image-container__DADwq","image":"CaseCard_image__FWfEg","text":"CaseCard_text__Xj4Kb"};